/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

const checkF1 = mode => {
  if (!mode) {
    return false
  }
  if (typeof(mode) === 'string') {
    return mode === 'true'
  }
  return mode
}
console.log(process.env);
export const isF1 = checkF1(process.env.VUE_APP_IS_F1);

const imagesF1 = {
  car: {
    alt: 'Empty comparison',
    src: require('@/assets/images/f1/CarF1.svg'),
    width: 590,
    height: 196,
  },
  badge: {
    alt: 'F1 logo',
    src: require('@/assets/images/f1/Badge.svg'),
    width: 72,
    height: 16,
  },
  badgeColor: {
    alt: 'F1',
    src: require('@/assets/images/f1/Badge.svg'),
    width: 72,
    height: 16,
  },
  raceLogo: {
    alt: 'Race logo',
    src: require('@/assets/images/f1/McLarenLogo.svg'),
    width: 112,
    height: 16,
  },
}

const imagesNascar = {
  car: {
    alt: 'Empty comparison',
    src: require('@/assets/images/HendrickCar.svg'),
    width: 600,
    height: 176,
  },
  badge: {
    alt: 'NASCAR logo',
    src: require('@/assets/images/NascarBadge.svg'),
    width: 40,
    height: 24,
  },
  badgeColor: {
    alt: 'Nascar',
    src: require('@/assets/images/NascarBadgeGrey.svg'),
    width: 34,
    height: 21,
  },
  raceLogo: {
    alt: 'Race logo',
    src: require('@/assets/images/RaceSmall.svg'),
    width: 112,
    height: 16,
  },
}

export default {
  images: isF1 ? imagesF1 : imagesNascar,
  isF1,
}
